(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldFreetext', fbFieldFreetextDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/freetext';

    function fbFieldFreetextDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: '=',
                model: '='
            },
            template: function(elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            bindToController: true,
            controllerAs: 'vm',
            controller: fbFieldFreetextDirectiveCtrl
        };
    }

    function fbFieldFreetextDirectiveCtrl(lodash, FormBuilderService, $scope, $timeout, $element) {
        var vm = this;
        this.$onInit = function() {var formIdentifier = $scope.$parent.vm.formIdentifier;

            FormBuilderService.sync(formIdentifier, vm);

            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            const cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');

            vm.tinymceOptions = angular.merge(
                {},
                {
                    plugins: 'link image autoresize paste lists table advlist visualblocks visualchars charmap',
                    menubar: false,
                    toolbar: 'undo redo | bold italic underline | bullist numlist | outdent indent',
                    preview_styles: false,
                    resize: true,
                    statusbar: false,
                    autoresize_bottom_margin: 0,
                    autoresize_min_height: 50,
                    debounce: false,
                    content_css: cdnEp + '/assets/css/rms-tinymce.css',
                    // paste_as_text: true,
                    paste_data_images: false
                    // paste_word_valid_elements: "b,strong,i,em,h1,h2,table,tr,td,ul,ol,li"
                },
                lodash.get(vm.element, 'options.tinymce', {}),
                {
                    setup: function (ed) {
                        ed.on('blur', function () {
                            vm.onEventTrigger('onBlur');
                        });
                        ed.on('init', function () {
                            $timeout(function () {
                                vm.pageData.currentScope.form.$setPristine();
                                vm.pageData.currentScope.form.$setUntouched();

                                $timeout(function() {
                                    var em = $element.find('.mce-toolbar-grp');
                                    $element.remove('.mce-toolbar-grp');
                                    $element.find('.mce-edit-area').after(em);
                                });
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    ed.setMode('readonly');
                                }
                            });
                        });
                        ed.on('PastePreProcess', function (e) {
                            console.log(e.content);
                        });
                    },
                    paste_preprocess: function (plugin, args) {
                        args.content = args.content.replace(/(<br[\s\/]*>)/g, '');
                    }
                }
            );
        }

    }
})();